import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useCountries() {
  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.countries.index)
      .then((response) => {
        setCountries(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, countries };
}
